import { getItem, setItem } from '../storage/jsonStorage.js';
const LOCAL_STORAGE_KEY = 'CVENT_ANALYTICS_GLOBAL_ACTION_PROPS';
/**
 * Global Action Props are properties defined to be applied to all actions that are tracked. These are usually things
 * we know about the user / session that aren't specific to a given action.
 *
 * Global Action props are stored in Local Storage and available for roughly 365 days from when they are set. This function
 * should only be called from the browser. Calling it in the context of a server will do nothing.
 *
 * NOTE: Please note that values stored here will also include the user's traits.
 */
export function updateGlobalActionProperties(props) {
    // Read existing value from local storage
    const existingProps = getItem(LOCAL_STORAGE_KEY);
    // Combine existing and new properties
    const combinedProps = { ...existingProps, ...props };
    // Ensure only the updated values are overwritten
    setItem(LOCAL_STORAGE_KEY, combinedProps);
    // TODO - work out the typing
    return combinedProps;
}
export function getGlobalActionProperties() {
    return getItem(LOCAL_STORAGE_KEY);
}
//# sourceMappingURL=globalActionProperties.js.map